import { toRefs, reactive } from "vue";

/**
 *
 */
const useAutoComplete = ({options, optionsKey}) => {
  let state = reactive({
    userInput: "",
    filteredSuggestions: [],
    suggestions: options,
    selectedItem: {}
  });

  let selected = _item => {
    const keyParsed = (typeof optionsKey == 'function') ? optionsKey({element: _item}) : optionsKey
    state.userInput = keyParsed;
    state.filteredSuggestions = [];
    state.selectedItem = { userInput: state.userInput, item: _item };
  };

  let onChange = _event => {
    let i = _event.target.value;
    state.userInput = i
    state.selectedItem = { userInput: state.userInput, item: null };
    if (i.length === 0) {
      state.filteredSuggestions = [];
      return;
    }
    
    const r = state.suggestions ? state.suggestions.filter( suggestion =>  {
      const keyParsed = (typeof optionsKey == 'function') ? optionsKey({element: suggestion}) : optionsKey
      return  keyParsed.toLowerCase().indexOf(i.toLowerCase()) > -1
    }) : []
    state.filteredSuggestions = r
  };
  return {
    ...toRefs(state),
    selected,
    onChange
  };
};

export default useAutoComplete;
